var render = function render(){var _vm=this,_c=_vm._self._c;return _c('catalog-complex-card',{attrs:{"complex":_vm.complex,"is-slider":_vm.isSlider}})
}
var staticRenderFns = []

export { render, staticRenderFns }